import Route from 'cio/routes/base';
import IntegrationsMparticleController from './controller';

export default class IntegrationsMparticleRoute extends Route {
  resetController(controller: IntegrationsMparticleController, isExiting: boolean) {
    if (isExiting) {
      controller.resetDefaults();
    }
  }
}
